import * as React from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import './RoleManagementStyling.css';
import { editRole } from '../../ApiUtils/ApiUtils';
import { Role } from './RoleList';

//export interface Role {
//    name: string,
//    description: string,
//    composite: boolean,
//    clientRole: boolean,
//    containerId: string,
//}

const InitialState: { name: string, description: string, composite: boolean, clientRole: boolean, nameError: string} = {
    name: "",
    description: "",
    composite: false,
    clientRole: false,
    nameError: "",
}
type State = typeof InitialState;

type RoleEditFormProps = {
    roleProp: any;
    clientProp: any;
    realmName: string;
    toggleDialog: (name?: string, roleToEdit?: Role, editted?: boolean) => void;
}

class RoleEditForm extends React.Component<RoleEditFormProps, State> {

    public constructor(props: RoleEditFormProps) {
        super(props);
        this.state = {
            name: this.props.roleProp.name,
            description: this.props.roleProp.description,
            composite: this.props.roleProp.composite,
            clientRole: this.props.roleProp.clientRole,
            nameError: "",
        };
    }

    componentDidMount() {
    }

    private handleSubmit = (e: React.ChangeEvent<any>) => {
        event?.preventDefault();
        if (e.target.elements.name.value === "root" || e.target.elements.name.value === "access" || e.target.elements.name.value === "admin") {
            event?.preventDefault();
            this.setState({ nameError: "Cannot create role with name " + e.target.elements.name.value });
        }
        if (e.target.elements.name.value.trim() === "") {
            this.setState({ nameError: "Cannot create role with blank name." });
        }
        else {
            this.setState({ nameError: "" });
            const edittedRole: Role = {
                name: this.state.name,
                description: this.state.description,
                composite: false,
                clientRole: true,
                containerId: this.props.clientProp.id
            };
            editRole(edittedRole, this.props.realmName, this.props.clientProp.id, this.props.roleProp.name);
            this.props.toggleDialog("", this.props.roleProp, true);
        }
    }

    private handleChange = (e: React.ChangeEvent<any>) => {
        let value;
        if (e.target.type === 'checkbox') {
            value = e.target.checked;
        }
        else {
            /*if (e.currentTarget.value.includes(":")) {
                e.currentTarget.value = e.currentTarget.value.replace(/:/g, "");
            }*/
            value = e.target.value;
        }
        this.setState({ ...this.state, [e.target.name]: value });
    }

    public render() {
        return (
            <>
                <Dialog
                    title={"Configure Role"}
                    onClose={() => this.props.toggleDialog()}
                    style={{ fontSize: "8px" }}
                    width={500}
                    height={"100%"}
                >
                    <form onSubmit={this.handleSubmit} style={{ fontSize: "11px", padding: "10px 15px 0px" }}>
                        <div>
                            <div>
                                <label htmlFor="name">Name</label><br/>
                                <input type="text" name="name" id="name" className="form-control" value={this.state.name} onChange={(e) => this.handleChange(e)}/><br/><br/>
                                {this.state.nameError && (
                                    <>
                                        <span className="error-span">{this.state.nameError}</span><br /><br />
                                    </>
                                )}
                                <label htmlFor="description">Description</label><br />
                                <input type="text" name="description" id="description" className="form-control" value={this.state.description} onChange={(e) => this.handleChange(e)} /><br /><br />
                                <hr />
                            </div>
                        </div>
                        <input type="submit" value="Submit" className={"btn btn-primary"} style={{ marginRight: "10px" }} />
                        <button className={"btn btn-secondary"} style={{ marginRight: "15px" }} onClick={() => this.props.toggleDialog()}>Cancel</button>
                    </form>
                </Dialog>
            </>
        );
    }
}

export default RoleEditForm;